// extracted by mini-css-extract-plugin
export default {"footer":"CVMFooter_footer__T9ffx","root":"CVMFooter_root__jfCJA"};